import "./team.css";

import React from "react";

import { TEAM, TEAM_TAGLINE } from "../../data/content";
import PageMeta from "../general/PageMeta";

//Anchor id for a team member's card, e.g. "carina-strydom" (used by the home page carousel links)
export const teamMemberId = (member) => member.name
  .normalize("NFD")
  .replace(/\p{Diacritic}/gu, "") //Remove accents (Anlé -> Anle)
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-|-$/g, "");

const TeamMember = ({ member }) => {
  const id = teamMemberId(member);

  return (
    <article
      id={id}
      className={"team-card"}
    >
      <img
        src={member.photo}
        alt={member.name}
        className={"team-card-photo"}
        width={720}
        height={1080}
        loading={"lazy"}
      />
      <div className={"team-card-body"}>
        <h2 className={"team-card-name"}>{member.name}</h2>
        <p className={"team-card-role"}>{member.role}</p>
        {member.email ? (
          <a
            href={`mailto:${member.email}`}
            className={"team-card-email"}
          >
            {member.email}
          </a>
        ) : null}
        <div className={"team-card-bio"}>
          {member.bio.map((paragraph) => (
            <p key={paragraph.slice(0, 20)}>{paragraph}</p>
          ))}
        </div>
      </div>
    </article>
  );
};

const Team = () => {
  return (
    <section className={"team-page"}>
      <PageMeta title={"about U Team"} />
      <div className={"container"}>
        <header className={"team-header"}>
          <h1 className={"section-title"}>Meet the about U Team</h1>
          <span className={"title-rule is-yellow"} />
          <p className={"team-tagline"}>{TEAM_TAGLINE}</p>
        </header>

        <div className={"team-list"}>
          {TEAM.map((member) => (
            <TeamMember
              key={member.name}
              member={member}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
